<mat-expansion-panel
    [expanded]="true"
    [togglePosition]="'before'"
    title="{{ hoverText }}"
    [ngClass]="panelFrameClasses"
>
    <mat-expansion-panel-header
        [collapsedHeight]="'2em'"
        [expandedHeight]="'2em'"
        [ngClass]="panelClasses"
    >
        <div class="panel-title">{{ title }}</div>
        <div class="panel-subtitle">{{ subTitle }}</div>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
    <ng-template [ngIf]="loading && !error">Loading {{ title }} ...</ng-template>
    <ng-template [ngIf]="error">Error Loading {{ title }}</ng-template>
</mat-expansion-panel>
